<template>
  <div class="index">
  </div>
</template>

<script>
export default{
  name:"Index",
  props:{

  },
  data(){
    return{}
  },
  methods:{
  },
  created(){}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/collection/case_detail/index.vue